///<reference path="../Const.ts"/>
///<reference path="../../libs/info/imagelogic/NumberTools.ts"/>

namespace app.util{
	import zerofill = info.imagelogic.NumberTools.zerofill;

	export class SDTDate{
		private date:Date;

		constructor(str?:string, format?:string){
			this.date = new Date();
			this.setAsString(str, format);
		};

		public setAsRawDate(date:Date){
			this.date = new Date(date.getTime());
		}

		public setAsString(str:string, format:string){
			let year = this.date.getFullYear(),
				month = this.date.getMonth() + 1,
				day  = this.date.getDate(),
				hour = 0,
				min = 0,
				r:RegExpMatchArray;
			// console.log(str);
			switch(format){
				case Const.DATE_CHOSEKI :
					year = parseInt(str.slice(0,4));
					month = parseInt(str.slice(4,6));
					day = parseInt(str.slice(6,8));
					break;
				case Const.DATE_PINPOINT_BASE:
					year = parseInt(str.slice(0,4));
					month = parseInt(str.slice(4,6));
					day = parseInt(str.slice(6,8));
					hour = parseInt(str.slice(8,10));
					break;

				case Const.DATE_PINPOINT_CREATION:
					r = str.match(/(.*)年(.*)月(.*)日(.*)時/);
					year = parseInt(r[1]);
					month = parseInt(r[2]);
					day = parseInt(r[3]);
					hour = parseInt(r[4]);
					break;

				case Const.DATE_PINPOINT_ITEM:
					month = parseInt(str.slice(0,2));
					day = parseInt(str.slice(2,4));
					hour = parseInt(str.slice(4,6));
					break;

				case Const.DATE_WEEKLY:
					month = parseInt(str.slice(0,2));
					day = parseInt(str.slice(3,5));
					break;

				case Const.DATE_WARN:
					r = str.match(/(.*)年(.*)月(.*)日(.*)時(.*)分/);
					year = parseInt(r[1]);
					month = parseInt(r[2]);
					day = parseInt(r[3]);
					hour = parseInt(r[4]);
					min = parseInt(r[5]);
					break;
				case Const.DATE_WEEKLY_CREATION:
					let d = new Date(parseInt(str)* 1000);
					year = d.getFullYear();
					month = d.getMonth() + 1;
					day  = d.getDate();
					hour = d.getHours();
					min = d.getMinutes();
			}

			this.date.setFullYear(year, month-1, day);
			this.date.setHours(hour, min, 0);

			// console.log(this.date);
		}

		public toString(format:string = null):string{
			let str:string = "",
				year = this.date.getFullYear(),
				month = this.date.getMonth() + 1,
				day  = this.date.getDate(),
				hour = this.date.getHours(),
				min = this.date.getMinutes();

			switch (format){
				case Const.DATE_DEFAULT:
					str = `${month}月${day}日`;
					break;
				case Const.TIME_DEFAULT:
					str = `${zerofill(hour)}:${zerofill(min)}`;
					break;
				case Const.DATE_PINPOINT_CREATION:
					str = `${year}年${month}月${day}日 ${hour}時発表`;
					break;
				case Const.DATE_WARN:
					str = `${year}年${month}月${day}日 ${hour}時${min}分発表`;
					break;

				default:
					str = this.date.toString();
			}
			return str;
		}

		public copy():SDTDate{
			let r = new SDTDate();
			r.setAsRawDate(this.date);

			return r
		}

		public addDay(num:number){
			this.date.setDate(this.date.getDate() + num);
		}
		public addHour(num:number){
			this.date.setHours(this.date.getHours() + num);
		}
		public addYear(num:number){
			this.date.setFullYear(this.date.getFullYear() + num);
		}

		public getIsToday(today:SDTDate):boolean{
			return this.date.getDate() == today.rawDate.getDate();
		}

		public getIsTomorrow(today:SDTDate):boolean{
			let tomorrow:Date = new Date(today.rawDate.valueOf() + (1000 * 60 * 60 * 24));
			return this.date.getDate() == tomorrow.getDate();
		}

		public getMonth():number{
			return this.date.getMonth();
		}

		public get rawDate(){
			return this.date;
		}

		public get timeSpan():number{
			let h = this.date.getHours() - 1;
			if(h < 0 ){
				h = 0;
			}
			return Math.floor(h / 6);
		}


	}
}